@switch (state) {
  @case ('loading') {
    <div class="thp-form-container" id="video-interview-page-container">
      <div class="thp-message">
        <h1 id="video-interview-page-header" class="thp-header">{{ "talent-happy-path.video-interview.page.header" | translate }}</h1>
        <p id="video-interview-page-loading" class="thp-sub-header">{{ "talent-happy-path.video-interview.page.loading" | translate }}</p>
        <div class="spinner-container">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button mat-button id="video-interview-page-do-later" class="later-button" (click)="clickIllDoThisLater()">
        {{ "talent-happy-path.buttons.do-later" | translate }}
      </button>
    </div>
  }

  @case ('recording') {
    <div class="thp-form-container video-interview-recording" id="video-interview-page-container">
      <div class="thp-message">
        <h1 id="video-interview-page-header" class="thp-header">{{ "talent-happy-path.video-interview.page.header" | translate }}</h1>
        <p id="video-interview-page-sub-header" class="thp-sub-header">{{ "talent-happy-path.video-interview.page.body" | translate }}</p>
      </div>
      <!-- allow="camera;microphone" is the vendor's documented requirement. No sandbox: it breaks
           the vendor page's own scripts. -->
      <iframe #videoInterviewFrame
              id="video-interview-frame"
              class="video-interview-frame"
              [src]="embedSrc"
              [title]="'talent-happy-path.video-interview.page.iframe-title' | translate"
              allow="camera;microphone"></iframe>
      <p class="video-interview-escape-hatch">
        <!-- Three handlers to catch every way of opening a link: cmd/ctrl-click, middle-click, and
             the right-click or long-press menu. Over-triggering only reveals a button. -->
        <a id="video-interview-external-link" [href]="externalUrl" target="_blank" rel="noopener"
           (click)="clickOpenInNewTab()"
           (auxclick)="clickOpenInNewTab()"
           (contextmenu)="clickOpenInNewTab()">
          {{ "talent-happy-path.video-interview.page.open-in-new-tab" | translate }}
        </a>
      </p>
    </div>
    <div class="button-container">
      <!-- Recording in the frame advances on the vendor's finished message. Only a talent who left
           for a new tab has no such signal, so only they need a way to say they are done. -->
      @if (openedInNewTab) {
        <button mat-flat-button id="video-interview-page-continue-button" class="custom-button" (click)="clickContinue()">
          {{ "talent-happy-path.video-interview.page.continue-button" | translate }}
        </button>
      }
      <button mat-button id="video-interview-page-do-later" class="later-button" (click)="clickIllDoThisLater()">
        {{ "talent-happy-path.buttons.do-later" | translate }}
      </button>
    </div>
  }

  @case ('alreadyDone') {
    <div class="thp-form-container" id="video-interview-page-container">
      <div class="thp-message">
        <h1 id="video-interview-page-header" class="thp-header">{{ "talent-happy-path.video-interview.page.already-done.header" | translate }}</h1>
        <p id="video-interview-page-sub-header" class="thp-sub-header">{{ "talent-happy-path.video-interview.page.already-done.body" | translate }}</p>
      </div>
    </div>
    <div class="button-container">
      <button mat-flat-button id="video-interview-page-continue-button" class="custom-button" (click)="clickContinue()">
        {{ "talent-happy-path.video-interview.page.continue-button" | translate }}
      </button>
    </div>
  }

  @case ('deferred') {
    <div class="thp-form-container" id="video-interview-page-container">
      <div class="thp-message">
        <h1 id="video-interview-page-header" class="thp-header">{{ "talent-happy-path.video-interview.page.deferred.header" | translate }}</h1>
        <p id="video-interview-page-sub-header" class="thp-sub-header">{{ "talent-happy-path.video-interview.page.deferred.body" | translate }}</p>
      </div>
    </div>
    <div class="button-container">
      <button mat-flat-button id="video-interview-page-continue-button" class="custom-button" (click)="clickContinue()">
        {{ "talent-happy-path.video-interview.page.continue-button" | translate }}
      </button>
    </div>
  }
}
